import { WhiteboardControl, WhiteboardControlMenuItem } from './WhiteboardControl';
import { useWhiteboardControl } from './useWhiteboardControl';

export function WhiteboardControlWrapper() {
  const { canWhiteboard, isLoading, isWhiteboardMode, toggleWhiteboard } = useWhiteboardControl();

  if (!canWhiteboard) return;

  return <WhiteboardControl isWhiteboardMode={isWhiteboardMode} onClick={toggleWhiteboard} isLoading={isLoading} />;
}

export function WhiteboardControlMenuItemWrapper() {
  const { isWhiteboardMode, isLoading, canWhiteboard, toggleWhiteboard } = useWhiteboardControl();

  if (!canWhiteboard) return;

  return (
    <WhiteboardControlMenuItem isLoading={isLoading} isWhiteboardMode={isWhiteboardMode} onClick={toggleWhiteboard} />
  );
}
